import toast from 'react-hot-toast';

export const snackbar = (children: React.ReactNode) => {
  return toast(<div style={{ width: '100%' }}>{children}</div>, {
    duration: 6000,
    position: 'bottom-left',
    style: {
      backgroundColor: 'var(--inverseSurface)',
      color: 'var(--inverseOnSurface)',
      minWidth: '300px',
      maxWidth: '800px',
    },
  });
};
